import { Component, OnInit, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { UserService } from '../../../../../services/user.service';
import { AppConfig } from '../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-import-cyclists',
  templateUrl: './import-cyclists.component.html',
  styleUrls: ['./import-cyclists.component.scss'],
})
export class ImportCyclistsComponent implements OnInit {
  public partnerID: string;
  public serviceTypes: any = [];
  public importRecords: any = [];
  public uploading: boolean = false;
  public progress: number = 0;
  public progressValue: number = 0;
  public noEmailCount: number = 0;
  public noPhoneNumberCount: number = 0;
  public columns: any = [
    {
      header: this.translate.instant('general.headers.name'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.surname'),
      field: 'Surname',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone_number'),
      field: 'PhoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.import_status'),
      field: 'Status',
      type: 'string',
    },
  ];
  @ViewChild('fileUpload') fileUpload: any;

  constructor(
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    private userService: UserService,
    private appConfig: AppConfig,
    private translate: TranslateService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() { }

  importCyclists(event) {
    this.importRecords = [];
    this.noEmailCount = 0;
    this.noPhoneNumberCount = 0;
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsText(uploadFile);
    reader.onload = (file: any) => {
      var lines = file.target.result.split('\n');
      if (this.detectIfVend(lines)) {
        this.vendImport(lines);
      } else {
        this.genericImport(lines);
      }
    };
    this.fileUpload.nativeElement.value = '';
  }

  importData() {
    this.uploading = true;
    this.progress = 0;
    this.createUser();
  }

  createUser() {
    if (this.importRecords[this.progress] == null) {
      return;
    }

    let user = {
      ...this.importRecords[this.progress],
      ...{
        Username: this.importRecords[this.progress].Email
          ? this.importRecords[this.progress].Email
          : this.importRecords[this.progress].PhoneNumber.trim(),
        PhoneNumber: this.importRecords[this.progress].PhoneNumber.trim(),
        Password: this.appConfig.defaultUserPassword(),
        ConfirmPassword: this.appConfig.defaultUserPassword(),
        PartnerID: this.partnerID,
      },
    };
    let data = { Email: user.Username, PhoneNumber: user.PhoneNumber.trim() };
    this.userService.checkIfUserAvailable(data).subscribe((result) => {
      if (result.ReturnMessage.length === 0) {
        user.PartnerID = this.partnerID;
        this.userService.createCustomer(user).subscribe(
          (newUser) => {
            this.importRecords[this.progress].Status = this.translate.instant('bikeshop.cyclist.import.imported');
            this.nextUser();
            //this.partnerService
            //  .linkCyclistToPartner(this.partnerID, newUser.ID)
            //  .subscribe(
            //    (linked) => {
            //      this.importRecords[this.progress].Status =
            //        this.translate.instant('bikeshop.cyclist.import.imported');
            //      this.nextUser();
            //    },
            //    (err) => {
            //      this.partnerService
            //        .linkCyclistToPartner(this.partnerID, newUser.ID)
            //        .subscribe(
            //          (linked) => {
            //            this.importRecords[this.progress].Status =
            //              this.translate.instant(
            //                'bikeshop.cyclist.import.imported',
            //              );
            //            this.nextUser();
            //          },
            //          (err) => {
            //            this.nextUser();
            //          },
            //        );
            //    },
            //  );
          },
          async (error) => {
            this.importRecords[this.progress].Status = this.translate.instant(
              'bikeshop.cyclist.import.error_importing',
            );
            this.nextUser();
          },
        );
      }
      else if (result.ID != null && result.ID.length > 0) {
        //User exists, try to link to partner
        console.log('Exists, just linking');
        this.partnerService.linkCyclistToPartner(this.partnerID, result.ID).subscribe(linked => {
          this.importRecords[this.progress].Status = this.translate.instant('bikeshop.cyclist.import.imported');
          this.nextUser();
        },
          (err) => {
            this.partnerService.linkCyclistToPartner(this.partnerID, result.ID).subscribe(linked => {
              this.importRecords[this.progress].Status = this.translate.instant('bikeshop.cyclist.import.imported');
              this.nextUser();
            },
              (err) => {
                this.nextUser();
              });
          });
      }
      else {
        this.importRecords[this.progress].Status = this.translate.instant(
          'bikeshop.cyclist.import.user_exists',
        );
        this.nextUser();
      }
    });
  }

  nextUser() {
    if (this.progress < this.importRecords.length - 1) {
      this.progress += 1;
      this.progressValue = Math.floor(
        (this.progress / (this.importRecords.length - 1)) * 100,
      );

      this.createUser();
    } else {
      this.uploading = false;
    }
  }

  detectIfVend(lines) {
    var columns =
      lines[0].indexOf(',') > -1 ? lines[0].split(',') : lines[0].split(';');
    return (
      columns[0] === 'customer_code' &&
      columns[1] === 'first_name' &&
      columns[2] === 'last_name' &&
      columns[27] === 'email'
    );
  }

  vendImport(lines) {
    //Do a preclean up. Seems some records have lines breaks in the data, the goal is each line for Vend must have 35 columns
    for (var i = 1; i < lines.length; i++) {
      var columns =
        lines[i].indexOf(',') > -1 ? lines[i].split(',') : lines[i].split(';');
      if (columns.length < 35 && i < lines.length - 1) {
        lines[i] += lines[i + 1];
        lines.splice(i + 1, 1);
        this.vendImport(lines);
        return;
      }
    }

    lines.forEach((line, index, array) => {
      if (index > 0) {
        var columns =
          line.indexOf(',') > -1 ? line.split(',') : line.split(';');
        if (columns.length >= 27) {
          let record = {
            Name: columns[1].replace(/"/g, ''),
            Surname: columns[2].replace(/"/g, ''),
            Email: columns[27].replace(/"/g, ''),
            PhoneNumber: columns[25].replace(/"/g, ''),
          };
          this.noEmailCount += record.Email.length === 0 ? 1 : 0;
          this.noPhoneNumberCount += record.PhoneNumber.length === 0 ? 1 : 0;

          //Only import if there is an email address.
          if (record.Email.length > 0 || record.PhoneNumber.length > 0) {
            this.importRecords.push(record);
          }
        }
      }
    });
  }

  genericImport(lines) {
    lines.forEach((line, index, array) => {
      if (index > 0) {
        var columns =
          line.indexOf(',') > -1 ? line.split(',') : line.split(';');
        if (columns.length >= 4) {
          let record = {
            Name: columns[0],
            Surname: columns[1],
            Email: columns[2],
            PhoneNumber: columns[3],
          };
          this.noEmailCount += record.Email.length === 0 ? 1 : 0;
          this.noPhoneNumberCount += record.PhoneNumber.length === 0 ? 1 : 0;

          //Only import if there is an email address.
          if (record.Email.length > 0 || record.PhoneNumber.length > 0) {
            this.importRecords.push(record);
          }
        }
      }
    });
  }
}
